module.exports = __webpack_public_path__ + "static/media/graduation_logo.a64189c3.svg";